import { SpaceBetween } from "@amzn/awsui-components-console";
import { WorkflowModuleProps } from "@amzn/region-flex-interface-module-website-common";

export const MigrationStep = (props: WorkflowModuleProps) => {
  return (
    <SpaceBetween size="l">
      <div>Service Id: {props.serviceId}</div>
      <div>Migration Plan Id: {props.migrationPlanId}</div>
      <div>Workflow Id: {props.workflowId}</div>
      <div>Module Id: {props.moduleId}</div>
      <div>Module Version: {props.version}</div>
      <div>RFP Version: {props.rfpVersion}</div>
    </SpaceBetween>
  );
};
